<template>
  <div class="home">
    <div class="title">
      <h3>Kontot {{ loading ? 'bekräftas...' : 'bekräftat!' }}</h3>
    </div>
    <div v-if="loading"><p>Var god vänta...</p></div>
    <div v-else>
      <p>Ditt konto har nu bekräftats och du kan fortsätta använda appen. Om du skulle uppleva några problem, kontakta support@nexa.se.</p>
    </div>
  </div>
</template>

<style>

</style>

<script>
export default {
  name: 'ConfirmAccount',
  components: {},
  mounted () {
    setTimeout(() => {
      fetch(`https://api.systemnexa2.se/1/account/confirm`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: this.$route.params.code })
      })
      .then(res => res.json())
      .then(json => {
        this.loading = false
        console.log(json)
      })
    }, 500)
  },
  data: () => ({
    loading: true
  })
}
</script>
